import { Col, Row } from 'react-bootstrap';
import ClassSelects from '../components/ClassSelects';
import FilterSummary from '../components/FilterSummary';
import { useItemAnalysisContext } from '../utils/itemAnalysisContext';
import FilterHeader from '../components/filterHeader';
import AssignmentSelects from '../components/AssignmentSelects';
import { useGetClassAssignmentsMutation } from '../../../../../features/authentication/assignmentApislice';

const ItemAnalysis = () => {

  const { activeStep, classes, includeRemoved, setAssignments
    , setPrimaryAssignmentName, primaryAssignmentId, setPrimaryAssignmentId, setCompare1Name, compare1Id, setCompare1Id
    , setCompare2Name, compare2Id, setCompare2Id, setCompare3Name, compare3Id, setCompare3Id, setCompare4Name
    , compare4Id, setCompare4Id, setCompare5Name, compare5Id, setCompare5Id
  } = useItemAnalysisContext();
  const [getClassAssignments] = useGetClassAssignmentsMutation();
  
  const loadClassAssignments = async (selectedClassIds) => {
    setAssignments([]);
    if(!selectedClassIds)
    {
      selectedClassIds = classes.filter(x => x.selected)?.map(x=>x.id);
    }
    if (selectedClassIds?.length == 0) {
      resetSelectedAssignment(null);
      return;
    }

    const params = new URLSearchParams();
    selectedClassIds.forEach(item => params.append('classIds', item));
    params.append('displayDeleted', includeRemoved);
    params.append('searchKey', '');
  
    var result = await getClassAssignments(params.toString()).unwrap();
    if (result?.length > 0) {
      const updatedResult = result.map(x => ({
        id: x.id,
        name: `${x.isAssessment ? 'Assessment' : 'Assignment'}--${x.name}`,
        originalName: x.name,
        teacherName: x.teacherName
      }));
      setAssignments([{ id: 0, name: 'Select an Assignment...' , originalName : 'Select an Assignment...'}, ...updatedResult]);
    }
    resetSelectedAssignment(result);
  };

  const resetSelectedAssignment = (reportData)=>
  {
    if(primaryAssignmentId>0 && !reportData?.find(x=>x.id==primaryAssignmentId))
    {
      setPrimaryAssignmentId(0);
      setPrimaryAssignmentName('Select an Assignment...');
    }
    if(compare1Id>0 && !reportData?.find(x=>x.id==compare1Id))
    {
      setCompare1Id(0);
      setCompare1Name('Select an Assignment...');
    }
    if(compare2Id>0 && !reportData?.find(x=>x.id==compare2Id))
    {
      setCompare2Id(0);
      setCompare2Name('Select an Assignment...');
    }
    if(compare3Id>0 && !reportData?.find(x=>x.id==compare3Id))
    {
      setCompare3Id(0);
      setCompare3Name('Select an Assignment...');
    }
    if(compare4Id>0 && !reportData?.find(x=>x.id==compare4Id))
    {
      setCompare4Id(0);
      setCompare4Name('Select an Assignment...');
    }
    if(compare5Id>0 && !reportData?.find(x=>x.id==compare5Id))
    {
      setCompare5Id(0);
      setCompare5Name('Select an Assignment...');
    }
  };

  return (
    <>
      <Row className='m-0'>
        <Col>
          <Row className='bg-white mb-4 rounded-4 w-100'><Col><FilterHeader /></Col></Row>
          <Row className='w-100'>
            <Col className='bg-white col-9 pt-2 rounded-4'>
              {activeStep === 1 && <ClassSelects />}
              {activeStep === 2 && <AssignmentSelects loadClassAssignments={(cIds)=>loadClassAssignments(cIds)} />}
            </Col>
            <Col className='col-3'>
              <Row><Col className='bg-white p-4 rounded-4 ml-2'><FilterSummary loadClassAssignments={(cIds)=>loadClassAssignments(cIds)}  /></Col></Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ItemAnalysis;